export function generateBaseMapSvg({ widthIn, heightIn, ppi }) {
  const wIn = Number(widthIn) || 24;
  const hIn = Number(heightIn) || 36;
  const pxPerIn = Number(ppi) || 40;

  const w = Math.round(wIn * pxPerIn);
  const h = Math.round(hIn * pxPerIn);

  const minorStroke = '#e5e7eb'; // gray-200
  const majorStroke = '#cbd5e1'; // slate-300

  const lines = [];

  // Grid (1-inch)
  for (let i = 0; i <= wIn; i++) {
    const x = Math.round(i * pxPerIn) + 0.5; // crisp lines
    const isMajor = i % 6 === 0;
    lines.push(
      `<line x1="${x}" y1="0" x2="${x}" y2="${h}" stroke="${isMajor ? majorStroke : minorStroke}" stroke-width="1" />`
    );
  }
  for (let j = 0; j <= hIn; j++) {
    const y = Math.round(j * pxPerIn) + 0.5;
    const isMajor = j % 6 === 0;
    lines.push(
      `<line x1="0" y1="${y}" x2="${w}" y2="${y}" stroke="${isMajor ? majorStroke : minorStroke}" stroke-width="1" />`
    );
  }

  // Simple title block (bottom-right)
  const tbW = Math.min(Math.round(8 * pxPerIn), w - 10);
  const tbH = Math.min(Math.round(2.5 * pxPerIn), h - 10);
  const tbX = w - tbW - 0.5;
  const tbY = h - tbH - 0.5;

  return `<?xml version="1.0" encoding="UTF-8"?>
<svg xmlns="http://www.w3.org/2000/svg" width="${w}" height="${h}" viewBox="0 0 ${w} ${h}">
  <rect x="0" y="0" width="${w}" height="${h}" fill="#ffffff" />
  ${lines.join('\n  ')}
  <rect x="0.5" y="0.5" width="${w - 1}" height="${h - 1}" fill="none" stroke="#111827" stroke-width="2" />
  <rect x="${tbX}" y="${tbY}" width="${tbW}" height="${tbH}" fill="#ffffff" stroke="#111827" stroke-width="1" />
  <text x="${tbX + 10}" y="${tbY + 22}" font-family="Arial, sans-serif" font-size="14" fill="#111827">
    Base Map (${wIn}×${hIn})
  </text>
  <text x="${tbX + 10}" y="${tbY + 42}" font-family="Arial, sans-serif" font-size="12" fill="#374151">
    Grid: 1 inch
  </text>
</svg>`;
}

